import { medicalExamination } from "../../../model/medicalexamination";

export interface IState {
    medicalExaminations: Array<medicalExamination>;
    selectedMedicalExamination: medicalExamination | undefined;
    isLoadingMex: boolean;
}

export const DefaultState = (): IState => ({
    medicalExaminations: [],
    selectedMedicalExamination: undefined,
    isLoadingMex: false,
})
